<template>
  <div>
    <div class="top">
      <the-now-time></the-now-time>
    </div>
    <div class="content">
      <div class="content-left">
        <div class="head">
          <div :class="{ active: !isSelectAlert }">
            视频报警分析图
          </div>
          <div :class="{ active: isSelectAlert }">
            视频报警
          </div>
        </div>
        <!-- 视频报警分析 -->
        <div class="alert-analyse" v-if="!isSelectAlert">
          <!-- 区域内视频报警总数 -->
          <the-alert-num :num="totalAlarmNum"></the-alert-num>
          <!-- 视频报警饼图 -->
          <video-pie :echartsData="alarmInfo"></video-pie>
          <!-- 视频报警统计波图 -->
          <video-line :echartsData="alarmRecord"></video-line>
        </div>
        <!-- 视频报警 -->
        <div class="alert-video" v-if="isSelectAlert">
          <div class="alert-head">
            <div
              class="select-type"
              :class="{ active: alertType == '' }"
              @click="selectType('')"
            >
              <img
                src="@/assets/img/eduBigData/alert-icon-1.png"
                alt="全部警告"
              />
              <span>全部警告</span>
            </div>
            <div
              class="select-type"
              :class="{ active: alertType == 10014 }"
              @click="selectType(10014)"
            >
              <img
                src="@/assets/img/eduBigData/alert-icon-2.png"
                alt="区域入侵"
              />
              <span>区域入侵</span>
            </div>
            <div
              class="select-type"
              :class="{ active: alertType == 10013 }"
              @click="selectType(10013)"
            >
              <img
                src="@/assets/img/eduBigData/alert-icon-3.png"
                alt="越界报警"
              />
              <span>越界报警</span>
            </div>
            <div
              class="select-type"
              :class="{ active: alertType == 10026 }"
              @click="selectType(10026)"
            >
              <img
                src="@/assets/img/eduBigData/alert-icon-4.png"
                alt="人员密度"
              />
              <span>人员密度</span>
            </div>
          </div>
          <!-- 视频报警列表 -->
          <video-alert-list :alertList="alertList"></video-alert-list>
        </div>
      </div>
      <div class="content-center">
        <!-- 视频播放和轮播组件 -->
        <video-play-list></video-play-list>
      </div>
      <div class="content-right">
        <!-- 选择学校和教育局组件 -->
        <school-search-video :totalData="resData"></school-search-video>
      </div>
    </div>
  </div>
</template>

<script>
import theNowTime from "./components/theNowTime";
import theAlertNum from "./components/theAlertNum";
import videoPie from "./components/videoPie";
import videoLine from "./components/videoLine";
import videoAlertList from "./components/videoAlertList";
import videoPlayList from "./components/videoPlayList";
import schoolSearchVideo from "./components/schoolSearchVideo";
export default {
  name: "",
  components: {
    theNowTime,
    theAlertNum,
    videoPie,
    videoLine,
    videoAlertList,
    videoPlayList,
    schoolSearchVideo
  },
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      isSelectAlert: false,
      totalAlarmNum: 0,
      alarmInfo: [],
      alarmRecord: [],
      resData: {},
      schoolId: "",
      alertType: "",
      alertList: []
    };
  },
  created() {
    this.getEduSafetyCenter();
  },
  mounted() {},
  computed: {
    eduSelectInfo() {
      return this.$store.state.eduSelectInfo;
    },
    eduSelectSchool() {
      return this.$store.state.eduSelectSchool;
    }
  },
  watch: {
    eduSelectInfo(newVal) {
      // console.log(newVal)
      this.eduInfo = newVal;
      this.select(1);
    },
    eduSelectSchool() {
      this.select(2);
    }
  },
  methods: {
    select(num) {
      if (num == 1) {
        this.isSelectAlert = false;
        // this.getEduMonitorAlarm()
        this.getEduSafetyCenter();
      } else {
        this.isSelectAlert = true;
        this.selectType();
      }
    },
    // 选择报警类型
    selectType(type) {
      if (type) {
        this.alertType = type;
      } else {
        this.alertType = "";
      }
      this.getEduSchoolMonitorAlarm();
    },
    // 获取安全中心
    async getEduSafetyCenter() {
      // console.log(this.eduInfo)
      let req = {
        eduId: this.eduInfo.eduId,
        regionCode: parseInt(this.eduInfo.regionCode),
        eduBuresuType: this.eduInfo.eduBuresuType
      };
      let res = await this.$Http.getEduSafetyCenter(req);
      // console.log(res);
      if (res.code == 200) {
        if (res.data) {
          this.resData = res.data;
          this.totalAlarmNum = res.data.totalAlarmNum;
          let data = res.data.alarmInfo;
          let a = data.find((item, index) => {
            return item.num != 0;
          });
          if (a) {
            this.alarmInfo = data;
          } else {
            this.alarmInfo = data.map((item, index) => {
              item.num = 1;
              return item;
            });
          }
          this.alarmRecord = res.data.alarmRecord;
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    // 获取教育局监控报警信息
    // async getEduMonitorAlarm() {
    //   // console.log(this.eduInfo)
    //   let req = {
    //     eduId: this.eduInfo.eduId,
    //     regionCode: parseInt(this.eduInfo.regionCode),
    //     eduBuresuType: this.eduInfo.eduBuresuType,
    //   };
    //   let res = await this.$Http.getEduMonitorAlarm(req);
    //   // console.log(res);
    //   if (res.code == 200) {
    //     if (res.data) {
    //       // console.log(res.data)
    //       this.totalAlarmNum = res.data.totalAlarmNum || 0;
    //       this.alarmInfo = res.data.alarmInfo || [];
    //       this.alarmRecord = res.data.alarmRecord || [];
    //     }
    //   } else if (res.code == 101) {
    //   } else {
    //   }
    // },
    // 获取学校监控报警信息
    async getEduSchoolMonitorAlarm() {
      this.isSelectAlert = true;

      let type = this.alertType;
      let schoolId = this.eduSelectSchool.schoolId;
      let req = {
        schoolId: schoolId,
        type: type
      };

      // console.log(req);

      let res = await this.$Http.getEduSchoolMonitorAlarm(req);
      // console.log(res);
      if (res.code == 200) {
        if (res.data) {
          this.alertList = res.data;
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.top {
  margin-top: -20px;
  margin-bottom: 10px;
  width: 100%;
  padding: 0 7.45% 0 3.85%;
  display: flex;
  justify-content: flex-end;
}
.content {
  width: 100%;
  padding: 0 3.49% 0 3.85%;
  display: flex;
  justify-content: space-between;
  .content-left {
    margin-top: -30px;
    width: 21.41%;
    .head {
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        padding-bottom: 5px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ccd5ff;
        margin-right: 32px;
        // cursor: pointer;
        position: relative;
        top: 2px;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          font-size: 18px;
          font-weight: 500;
          color: #fffded;
          background: url("~@/assets/img/eduBigData/alert-select-active.png")
            center bottom no-repeat;
          cursor: default;
          top: 0;
        }
      }
    }
    .alert-analyse {
      width: 100%;
      height: 800px;
      background: url("~@/assets/img/eduBigData/big-data-alert-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
    }
    .alert-video {
      width: 100%;
      height: 800px;
      background: url("~@/assets/img/eduBigData/big-data-alert-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
      .alert-head {
        // height: 58px;
        padding: 14px 12px 0 12px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-bottom: 1px solid #2f318c;
        position: relative;
        .select-type {
          width: 78px;
          height: 58px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          opacity: 0.6;
          img {
            width: 18px;
            height: 18px;
          }
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
          }
          &.active {
            opacity: 1;
            &:after {
              content: "";
              width: 70px;
              height: 6px;
              background: url("~@/assets/img/eduBigData/alert-select-active.png")
                center center no-repeat;
              background-size: 100% 100%;
              position: absolute;
              // left: 2px;
              bottom: -3px;
            }
            span {
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .content-center {
    width: 48.23%;
  }
  .content-right {
    width: 21.41%;
    height: 800px;
    background: url("~@/assets/img/eduBigData/big-data-alert-bg.png") center
      center no-repeat;
    background-size: 100% 100%;
  }
}
</style>
